import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { camelize } from '../../util/string';
export const ASSET_NAME = 'country-landing-page';
export const ASSET_SUFFIX = '-landing-page';

export const formatCountry = (country) => country.toLowerCase().replace(/ /g, "-");

export const loadData = (params, search) => dispatch => {
  const { country } = params || {};
  const formattedCountry = formatCountry(country);
  const pageAsset = { [`${camelize(formattedCountry)}`]: `content/pages/${formattedCountry}.json` };

  return dispatch(fetchPageAssets(pageAsset, true));
};
